"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleType = exports.PersonaLinkRecordOrientation = void 0;
var PersonaLinkRecordOrientation;
(function (PersonaLinkRecordOrientation) {
    PersonaLinkRecordOrientation["INCLUSIONARY"] = "INCLUSIONARY";
    PersonaLinkRecordOrientation["EXCLUSIONARY"] = "EXCLUSIONARY";
})(PersonaLinkRecordOrientation || (exports.PersonaLinkRecordOrientation = PersonaLinkRecordOrientation = {}));
// AttributeType enum removed - replaced by flexible attributePath strings
var RuleType;
(function (RuleType) {
    RuleType["IS"] = "IS";
    RuleType["IS_NOT"] = "IS_NOT";
    RuleType["IS_ONE_OF"] = "IS_ONE_OF";
    RuleType["IS_NOT_ONE_OF"] = "IS_NOT_ONE_OF";
    RuleType["CONTAINS"] = "CONTAINS";
    RuleType["DOES_NOT_CONTAIN"] = "DOES_NOT_CONTAIN";
    RuleType["BETWEEN"] = "BETWEEN";
    RuleType["NOT_BETWEEN"] = "NOT_BETWEEN";
})(RuleType || (exports.RuleType = RuleType = {}));
